import qs from "qs";
import axios from "axios";
import config from "./config";
import cookie from "vue-cookie";
import router from "@/router";
import NProgress from "nprogress";
import ElementUI from "element-ui";
import debounce from "lodash.debounce"; // 防抖函数
import { clearCookies } from "@/services/common";
import { ensureMemberAccess } from "@/services/memberAccess";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });

const CancelToken = axios.CancelToken;
let cancel;

export const home_url = {
  UserApi: config.UserAPI,
  BaseApi: config.BaseAPI, //基础API路径
  BaseApi2: config.BaseAPI2, //基础API路径2
  BaseApi3: config.BaseAPI3,
  BaseApi4: config.BaseAPI4,
  BaseApi5: config.BaseAPI5,
  PaymentAPI: config.PaymentAPI,
};

export const apiRoot = function (path, serverType = "BaseApi") {
  return `${home_url[serverType]}${path}`;
};

//头部存储token信息
export const getHeader = () => {
  const data = cookie.get("token") || {};
  let href = window.location.href;
  if (href.length > 1000) {
    href = `${window.location.origin}/#/home/projectHome/fileList`;
  }
  let obj = {
    "Content-Type": "application/json;charset=UTF-8",
    "is-ajax-request": "true",
    "client-name": CAS_CLIENT_NAME,
    "redirect-url": href,
  };
  if (Reflect.has(data, "Authorization")) {
    obj["Authorization"] = cookie.get("token").Authorization;
  }
  return obj;
};

//头部存储用户信息
export const getHeader2 = () => {
  const data = cookie.load("token");
  return {
    userId: Reflect.has(data, "token") && cookie.load("token").id,
  };
};

//设置请求参数-固定参数
export const setParams = (params = {}) => {
  // 平台编码
  let PlatInfo = localStorage.myPlatformType;
  let CompanyCode = localStorage.companyCode;
  if (!!PlatInfo && PlatInfo.length > 0) {
    Reflect.set(params, "platformType", PlatInfo);
  } else {
    Reflect.set(params, "platformType", VUE_APP_PLATFORMTYPE);
  }
  // 公司编码
  // 没有sessionCompanyCode
  let sessionCompanyCode = sessionStorage.getItem("companyCode");
  if (!sessionCompanyCode) {
    if (!(!!params && !!params.companyCode)) {
      if (CompanyCode) {
        Reflect.set(params, "companyCode", CompanyCode);
      }
    }
  } else {
    if (!(!!params && !!params.companyCode)) {
      Reflect.set(params, "companyCode", sessionCompanyCode);
    }
  }

  // 给所有编辑器接口使用
  let transModel = sessionStorage.getItem("transModel");
  if (!(transModel === null)) {
    if (!(!!params && !!params.transModel)) {
      Reflect.set(params, "transModel", Number(transModel));
    }
  }

  // 注册传递空字符串需要用到判断
  if (!params.hasOwnProperty("sourceAppid")) {
    Reflect.set(params, "sourceAppid", localStorage.sourceAppid);
  }
  return params;
};

export const cancelPending = () => {
  cancel("用户取消操作.");
};

export const ajaxGetJson = async (path, params, serverType, shown = 1) => {
  if (!(await ensureMemberAccess(path, serverType))) return false;
  NProgress.start();
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      contentType: "application/json; charset=utf-8",
      headers: getHeader(),
      url: apiRoot(path, serverType),
      data: setParams(),
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    })
      .then((res) => {
        Reflect.set(res.data, "status", res.status);
        let data = res.data;
        resolve(data);
        if (!data.success && !!shown) {
          debounce(errorMessage(data), 1000);
        }
      })
      .catch((err) => {
        const errInfo = Object();
        if (err.response) {
          Reflect.set(errInfo, "status", err.response.status);
          Reflect.set(errInfo, "headers", err.response.headers);
          Reflect.set(errInfo, "data", err.response.data);
          browserErrorMessage(errInfo);
        }
        reject(errInfo);
      })
      .finally(() => {
        NProgress.done();
      });
  });
};

export const ajaxGetJson2 = async (path, params, serverType, shown = 1) => {
  if (!(await ensureMemberAccess(path, serverType))) return false;
  NProgress.start();
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      contentType: "application/json; charset=utf-8",
      headers: getHeader(),
      url: apiRoot(path, serverType),
      params: setParams(params),
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    })
      .then((res) => {
        Reflect.set(res.data, "status", res.status);
        let data = res.data;
        resolve(data);
        if (!data.success && !!shown) {
          debounce(errorMessage(data), 1000);
        }
      })
      .catch((err) => {
        const errInfo = Object();
        if (err.response) {
          Reflect.set(errInfo, "status", err.response.status);
          Reflect.set(errInfo, "headers", err.response.headers);
          Reflect.set(errInfo, "data", err.response.data);
          browserErrorMessage(errInfo);
        }
        reject(errInfo);
      })
      .finally(() => {
        NProgress.done();
      });
  });
};

export const ajaxPostJson = async (
  path,
  params = Object(),
  serverType,
  shown = 1,
  config = {}
) => {
  if (!(await ensureMemberAccess(path, serverType))) return false;
  NProgress.start();
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      contentType: "application/json; charset=utf-8",
      headers: getHeader(),
      url: apiRoot(path, serverType),
      data: setParams(params),
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
      ...config,
    })
      .then((res) => {
        Reflect.set(res.data, "status", res.status);
        let data = res.data;
        resolve(data);
        if (!data.success && !!shown) {
          debounce(errorMessage(data), 2500);
        }
      })
      .catch((err) => {
        const errInfo = Object();
        if (err.response) {
          Reflect.set(errInfo, "status", err.response.status);
          Reflect.set(errInfo, "headers", err.response.headers);
          Reflect.set(errInfo, "data", err.response.data);
          browserErrorMessage(errInfo);
        }
        reject(errInfo);
      })
      .finally(() => {
        NProgress.done();
      });
  });
};

export const ajaxDeleteJson = async (path, params, serverType) => {
  if (!(await ensureMemberAccess(path, serverType))) return false;
  return axios({
    method: "delete",
    contentType: "application/json; charset=utf-8",
    headers: getHeader(),
    url: apiRoot(path, serverType),
    data: setParams(params),
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  })
    .then((res) => {
      console.log(res);
      Reflect.set(res.data, "status", res.status);
      resolve(res.data);
    })
    .catch((err) => {
      console.log(err);
      reject(err.data);
    });
};

export const ajaxPutJson = async (path, params, serverType) => {
  if (!(await ensureMemberAccess(path, serverType))) return false;
  return axios({
    method: "put",
    contentType: "application/json; charset=utf-8",
    headers: getHeader(),
    url: apiRoot(path, serverType),
    data: setParams(params),
  });
};

export const ajaxGetForm = async (path, params, serverType) => {
  if (!(await ensureMemberAccess(path, serverType))) return false;
  return axios({
    method: "GET",
    contentType: "application/x-www-form-urlencoded",
    headers: getHeader(),
    url: apiRoot(path, serverType),
    data: qs.stringify(setParams(params)),
  });
};

export const ajaxPostForm = async (path, params, serverType) => {
  if (!(await ensureMemberAccess(path, serverType))) return false;
  return axios({
    method: "POST",
    contentType: "application/x-www-form-urlencoded",
    headers: getHeader(),
    url: apiRoot(path, serverType),
    data: qs.stringify(setParams(params)),
  });
};

export const ajaxUploadImg = async (path, file, serverType) => {
  if (!(await ensureMemberAccess(path, serverType))) return false;
  return axios({
    method: "POST",
    contentType: false,
    processData: false,
    headers: getHeader(),
    url: apiRoot(path, serverType),
    data: file,
  });
};

export const ajaxLogin = (path, params, serverType) => {
  return axios({
    method: "GET",
    url: apiRoot(path, serverType),
    data: params,
  });
};

export const debounceFn = (fn, delay, err) => {
  let timer = null;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      fn(err);
    }, delay);
  };
};

//错误统一处理
export const errorMessage = (err) => {
  let errorCode = err.errorCode;
  let errorDesc = err.errorDesc || "服务器错误,请稍后重试";
  if (errorCode === "CAT-V003") {
    router.push({
      name: "login",
    });
    return false;
  } else {
    ElementUI.Message({
      message: `${errorDesc}`,
      type: "error",
    });
  }
};

//浏览器错误-请求未进入后端处理
export const browserErrorMessage = (err) => {
  if (err.status === 401 && CAS_ENABLE) {
    localStorage.removeItem("myUser");
    clearCookies();
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = err.headers.location;
    return true;
  }
};
